"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var addReadWriteRecipient_1 = require("./addReadWriteRecipient");
var setFindResultSet_1 = require("./setFindResultSet");
var setIsSearching_1 = require("./setIsSearching");
var showHideFindResult_1 = require("./showHideFindResult");
var datapoints_1 = require("../datapoints");
var findPeople_1 = require("owa-recipient-common/lib/services/findPeople");
var ReadWriteRecipientWellViewState_1 = require("../store/schema/ReadWriteRecipientWellViewState");
var store_1 = require("../store/store");
var owa_analytics_1 = require("owa-analytics");
var searchCache_1 = require("owa-recipient-cache/lib/selectors/searchCache");
var isCacheEmpty_1 = require("owa-recipient-cache/lib/utils/isCacheEmpty");
var processFindPeopleResult_1 = require("owa-recipient-common/lib/actions/processFindPeopleResult");
var getPersonasFromReadWriteRecipientList_1 = require("owa-recipient-common/lib/utils/getPersonasFromReadWriteRecipientList");
var legacy_1 = require("satcheljs/lib/legacy");
var MAX_ENTRIES_TYPEDOWN = 5;
var MAX_ENTRIES_DIRECTORY = 20;
var FIND_PEOPLE_TIMEOUT = 1000;
var FIND_PEOPLE_REQUEST_COUNT_THRESHOLD = 3;
var handleLongDelay = function (recipientWell, queryString, resolveIfSingle, didTimeOut) { return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                didTimeOut.isTimedOut = true;
                return [4 /*yield*/, searchCacheFallback(recipientWell, queryString, resolveIfSingle, didTimeOut)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); }; };
var searchCacheFallback = legacy_1.action('searchCacheFallback')(function searchCacheFallback(recipientWell, queryString, resolveIfSingle, didTimeOut) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rcTopFive, personaTypeSet;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(recipientWell.queryString.trim() == queryString)) return [3 /*break*/, 3];
                    rcTopFive = searchCache_1.default(queryString, 5 /* numberOfResults */, getPersonasFromReadWriteRecipientList_1.default(recipientWell.recipients));
                    if (!(rcTopFive.length > 0)) return [3 /*break*/, 2];
                    personaTypeSet = rcTopFive.map(function (result) {
                        return {
                            EmailAddress: result.EmailAddress,
                            PersonaId: result.PersonaId,
                            ADObjectId: result.ADObjectId,
                        };
                    });
                    setIsSearching_1.default(recipientWell, false);
                    setFindResultSet_1.default(recipientWell, personaTypeSet);
                    return [4 /*yield*/, postProcessFindPeopleResult(recipientWell, ReadWriteRecipientWellViewState_1.FindRecipientResultType.Cache, resolveIfSingle)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (didTimeOut) {
                        didTimeOut.isCacheEmpty = true;
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
exports.default = legacy_1.action('findReadWriteRecipient')(function findReadWriteRecipient(recipientWell, queryString, searchDirectory, resolveIfSingle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var datapoint, didTimeOut, timeout, _a, _b, findPeopleResult, didAutoSearchDirectory, sameQueryString, maxFindResultShown, resultType, error_1, datapoint;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!recipientWell.shouldShowFindResult) {
                        showHideFindResult_1.default(recipientWell, true /* shouldShowFindResult */);
                    }
                    if (!(store_1.default.pendingFindPeopleRequests < FIND_PEOPLE_REQUEST_COUNT_THRESHOLD)) return [3 /*break*/, 12];
                    datapoint = new owa_analytics_1.PerformanceDatapoint(datapoints_1.default.SearchPeopleIndex.datapoint.name);
                    setIsSearching_1.default(recipientWell, true);
                    didTimeOut = { isTimedOut: false, isCacheEmpty: false };
                    if (!(searchDirectory || isCacheEmpty_1.default())) return [3 /*break*/, 1];
                    _a = null;
                    return [3 /*break*/, 3];
                case 1:
                    _b = setTimeout;
                    return [4 /*yield*/, handleLongDelay(recipientWell, queryString, resolveIfSingle, didTimeOut)];
                case 2:
                    _a = _b.apply(void 0, [_c.sent(),
                        FIND_PEOPLE_TIMEOUT]);
                    _c.label = 3;
                case 3:
                    timeout = _a;
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 10, , 11]);
                    store_1.default.pendingFindPeopleRequests++;
                    return [4 /*yield*/, findPeople_1.findPeople(queryString, searchDirectory)];
                case 5:
                    findPeopleResult = _c.sent();
                    store_1.default.pendingFindPeopleRequests--;
                    clearTimeout(timeout);
                    setIsSearching_1.default(recipientWell, false);
                    didAutoSearchDirectory = false;
                    sameQueryString = recipientWell.queryString.trim() == queryString;
                    if (!((!didTimeOut.isTimedOut || didTimeOut.isCacheEmpty) && sameQueryString)) return [3 /*break*/, 9];
                    maxFindResultShown = searchDirectory
                        ? MAX_ENTRIES_DIRECTORY
                        : MAX_ENTRIES_TYPEDOWN;
                    processFindPeopleResult_1.default(recipientWell.findResultSet, findPeopleResult, maxFindResultShown);
                    if (!(recipientWell.findResultSet.length > 0)) return [3 /*break*/, 7];
                    resultType = searchDirectory
                        ? ReadWriteRecipientWellViewState_1.FindRecipientResultType.SearchDirectory
                        : ReadWriteRecipientWellViewState_1.FindRecipientResultType.FindPeople;
                    return [4 /*yield*/, postProcessFindPeopleResult(recipientWell, resultType, resolveIfSingle)];
                case 6:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 7:
                    didAutoSearchDirectory = true;
                    return [4 /*yield*/, autoSearchDirectory(recipientWell, queryString, resolveIfSingle)];
                case 8:
                    _c.sent();
                    _c.label = 9;
                case 9:
                    datapoint.addCustomData([
                        didTimeOut.isTimedOut,
                        sameQueryString,
                        searchDirectory,
                        didTimeOut.isCacheEmpty,
                        didAutoSearchDirectory,
                    ]);
                    datapoint.end();
                    return [3 /*break*/, 11];
                case 10:
                    error_1 = _c.sent();
                    datapoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error_1);
                    return [3 /*break*/, 11];
                case 11: return [3 /*break*/, 14];
                case 12:
                    datapoint = new owa_analytics_1.PerformanceDatapoint(datapoints_1.default.FPThresholdHit.datapoint.name);
                    return [4 /*yield*/, searchCacheFallback(recipientWell, queryString, resolveIfSingle)];
                case 13:
                    _c.sent();
                    datapoint.end();
                    _c.label = 14;
                case 14: return [2 /*return*/];
            }
        });
    });
});
var autoSearchDirectory = legacy_1.action('autoSearchDirectory')(function autoSearchDirectory(recipientWell, queryString, resolveIfSingle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var findPeopleResult, sameQueryString, maxFindResultShown;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, findPeople_1.findPeople(queryString, true /* searchDirectory*/)];
                case 1:
                    findPeopleResult = _a.sent();
                    setIsSearching_1.default(recipientWell, false);
                    sameQueryString = recipientWell.queryString.trim() == queryString;
                    if (!sameQueryString) return [3 /*break*/, 3];
                    maxFindResultShown = MAX_ENTRIES_DIRECTORY;
                    processFindPeopleResult_1.default(recipientWell.findResultSet, findPeopleResult, maxFindResultShown);
                    recipientWell.hasSearchedDirectory = true;
                    return [4 /*yield*/, postProcessFindPeopleResult(recipientWell, ReadWriteRecipientWellViewState_1.FindRecipientResultType.SearchDirectory, resolveIfSingle)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
var postProcessFindPeopleResult = legacy_1.action('postProcessFindPeopleResult')(function postProcessFindPeopleResult(recipientWell, resultType, resolveIfSingle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(recipientWell.findResultSet.length == 1 && resolveIfSingle)) return [3 /*break*/, 2];
                    // Autoresolve if there's only a single result.
                    return [4 /*yield*/, addReadWriteRecipient_1.default(recipientWell, true /* isValid */, recipientWell.findResultSet[0], null /* newEmailAddress */)];
                case 1:
                    // Autoresolve if there's only a single result.
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    recipientWell.findResultType = resultType;
                    showHideFindResult_1.default(recipientWell, true /* shouldShowFindResult */);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=findReadWriteRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/findReadWriteRecipient.js
// module id = 2708
// module chunks = 2 3 4 45